<template>
  <div>
    <div  class="iphone-bottom-menu" >    
        <div class="iphone-btn modbtn" @click="opens" > <b-icon icon="share" aria-hidden="true"></b-icon> 分享</div>           
        <div class="iphone-btn leftbtn" @click="viewour" ><b-icon icon="person-circle" aria-hidden="true"></b-icon> 主辦單位 </div> 
        <div v-if="obj.states=='Y'" class="iphone-btn rightbtn" @click="joinact" ><b-icon icon="bar-chart-fill" aria-hidden="true"></b-icon> 立即報名</div>  
        <div v-else class="iphone-btn disabled-btn" />         
    </div>  
  </div>
</template>

<script>
import router from '../../router'
import { checktokens } from "../../api/utils";
import {mapState} from 'vuex';



export default {
  name: "Bottommenu",
  props: {
    obj: Object, 
  },
  data() {
    return {     
      xurl: "",
      imgs: {
        width: 0,
        height: 0
      },

    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
  },
  methods: {

    catImg(imgs) {
      return require(`../../assets/${imgs}`);
    },

    covert(type,val){
      if(type=='theme'){        
        let rs= this.mytheme.filter((el)=> { return el.value === val});
        return rs[0].title;
      }
    },

    opens(){
      this.$emit("openshare")  
    },
    viewour(){   
        router.push({ name: 'Outorg', params: { id: this.obj.orgid,type:'Y' }})   
    },
    
    joinact(){
        if(this.user!==null){
            let verify= checktokens(String(this.status.token))                    
            if(verify===null){
                this.$emit("showmessage",'請先登入, 謝謝!')    
            }else{
              router.push({ name: 'Regjoin', params: { id: this.obj.id,type :'Y' }})
            }
        }else{
          this.$emit("showmessage",'請先登入, 謝謝!')    
        }
    },      

  },

};
</script>
<style scoped>
.iphone-bottom-menu {
  display: flex; /* 使用 Flexbox 排版 */
  justify-content: space-between; /* 子元素均勻分布 */
  align-items: center; /* 垂直居中 */
  width: 100%; /* 占滿父容器寬度 */
  max-height: 60px; /* 限制高度 */
  background-color: #f9f9f9; /* 柔和背景色 */
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1); /* 添加陰影 */
  border-top: 1px solid #e0e0e0; /* 添加邊框 */
}

.iphone-btn {
  flex: 1; /* 子元素等寬 */
  text-align: center; /* 文字居中 */
  line-height: 60px; /* 垂直居中 */
  font-size: 0.9rem; /* 調整文字大小 */
  font-weight: bold; /* 加粗文字 */
  color: #666666; /* 文字顏色改為深灰色 */
  cursor: pointer; /* 鼠標樣式 */
  transition: background-color 0.3s ease; /* 添加過渡效果 */
}

.modbtn {
  flex: 0.7; /* 分享按鈕最小 */
  background-color: #e8e8e8; /* 分享按鈕背景色 - 淺灰白 */
}

.modbtn:hover {
  background-color: #dadada; /* 分享按鈕 hover 效果 */
}

.leftbtn {
  flex: 1.1; /* 主辦單位按鈕中等 */
  background-color: #f2f2f2; /* 主辦單位按鈕背景色 - 淡灰白 */
}

.leftbtn:hover {
  background-color: #eeeeee; /* 主辦單位按鈕 hover 效果 */
}

.rightbtn {
  flex: 1.2; /* 報名按鈕最大 */
  background-color: #f5f5f5; /* 報名按鈕背景色 - 明顯灰白 */
  border: 1px solid #ccc; /* 添加明顯邊框增加層次 */
}

.rightbtn:hover {
  background-color: #eeeeee; /* 報名按鈕 hover 效果 */
}

.disabled-btn {
  flex: 1.2; /* 已結束按鈕與報名按鈕同寬 */
  background-color: #e0e0e0; /* 已結束按鈕背景色 */
  color: #9e9e9e; /* 已結束按鈕文字顏色 */
  cursor: not-allowed; /* 禁用鼠標樣式 */
}
 
</style>


